(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('FrequencyController', FrequencyController);

    FrequencyController.$inject = ['$scope', '$state', 'Frequency', 'FrequencySearch'];

    function FrequencyController ($scope, $state, Frequency, FrequencySearch) {
        var vm = this;

        vm.frequencies = [];
        vm.search = search;

        loadAll();

        function loadAll() {
            Frequency.query(function(result) {
                vm.frequencies = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            FrequencySearch.query({query: vm.searchQuery}, function(result) {
                vm.frequencies = result;
            });
        }    }
})();
